class CustomRedirection extends HTMLElement {
  constructor() {
    super();

    const redirection_status = sessionStorage.getItem('redirection_status');
    if (redirection_status === 'true') return;
    this.getAllCountries();
    this.checkUserCountry().then(data => {
      const store_country = document.querySelector('[data-store-country]')?.innerHTML;
      const country = data.detected_values.country.handle;
      this.countries.forEach(item => {
        if (item.countries_list.includes(country)) {
          if (item.current_country !== store_country) {
            this.renderPopup(item);
          }
        }
      })
    }).catch((error) => {
      console.error(error);
    });
    this.popupModalToggle();
  }

  async checkUserCountry() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  getAllCountries() {
    const au_text_one = document.querySelector('[data-au-text-one]')?.innerHTML ? document.querySelector('[data-au-text-one]')?.innerHTML : '';
    const au_text_two = document.querySelector('[data-au-text-two]')?.innerHTML ? document.querySelector('[data-au-text-two]')?.innerHTML : '';
    const au_store_url = document.querySelector('[data-au-store-url]')?.innerHTML ?document.querySelector('[data-au-store-url]')?.innerHTML : '';
    const au_redirect_countries = document.querySelector('[data-au-redirect-countries]')?.innerHTML;
    const au_redirect_countries_list = au_redirect_countries ? au_redirect_countries.split(',') : [];
    const au_obj = {
      'current_country': 'AU',
      'text_one': au_text_one,
      'text_two': au_text_two,
      'store_url': au_store_url,
      'countries_list': au_redirect_countries_list
    }

    const us_text_one = document.querySelector('[data-us-text-one]')?.innerHTML ? document.querySelector('[data-us-text-one]')?.innerHTML : '';
    const us_text_two = document.querySelector('[data-us-text-two]')?.innerHTML ? document.querySelector('[data-us-text-two]')?.innerHTML : '';
    const us_store_url = document.querySelector('[data-us-store-url]')?.innerHTML ? document.querySelector('[data-us-store-url]')?.innerHTML : '';
    const us_redirect_countries = document.querySelector('[data-us-redirect-countries]')?.innerHTML;
    const us_redirect_countries_list = us_redirect_countries ? us_redirect_countries.split(',') : [];
    const us_obj = {
      'current_country': 'US',
      'text_one': us_text_one,
      'text_two': us_text_two,
      'store_url': us_store_url,
      'countries_list': us_redirect_countries_list
    }

    const uk_text_one = document.querySelector('[data-uk-text-one]')?.innerHTML ? document.querySelector('[data-uk-text-one]')?.innerHTML : '';
    const uk_text_two = document.querySelector('[data-uk-text-two]')?.innerHTML ? document.querySelector('[data-uk-text-two]')?.innerHTML : '';
    const uk_store_url = document.querySelector('[data-uk-store-url]')?.innerHTML ? document.querySelector('[data-uk-store-url]')?.innerHTML : '';
    const uk_redirect_countries = document.querySelector('[data-uk-redirect-countries]')?.innerHTML;
    const uk_redirect_countries_list = uk_redirect_countries ? uk_redirect_countries.split(',') : [];
    const uk_obj = {
      'current_country': 'UK',
      'text_one': uk_text_one,
      'text_two': uk_text_two,
      'store_url': uk_store_url,
      'countries_list': uk_redirect_countries_list
    }

    const eu_text_one = document.querySelector('[data-eu-text-one]')?.innerHTML ? document.querySelector('[data-eu-text-one]')?.innerHTML : '';
    const eu_text_two = document.querySelector('[data-eu-text-two]')?.innerHTML ? document.querySelector('[data-eu-text-two]')?.innerHTML : '';
    const eu_store_url = document.querySelector('[data-eu-store-url]')?.innerHTML ? document.querySelector('[data-eu-store-url]')?.innerHTML : '';
    const eu_redirect_countries = document.querySelector('[data-eu-redirect-countries]')?.innerHTML;
    const eu_redirect_countries_list = eu_redirect_countries ? eu_redirect_countries.split(',') : [];
    const eu_obj = {
      'current_country': 'EU',
      'text_one': eu_text_one,
      'text_two': eu_text_two,
      'store_url': eu_store_url,
      'countries_list': eu_redirect_countries_list
    }

    this.countries = [au_obj, us_obj, uk_obj, eu_obj];
  }

  renderPopup(data){
    const redirectionModal = document.querySelector('#custom-redirection-modal');
    const redirectionModal_text_one = redirectionModal?.querySelector('.crm-text-one');
    const redirectionModal_text_two = redirectionModal?.querySelector('.crm-text-two');
    const redirectionModal_url = redirectionModal?.querySelector('#crm-redirection-url');
    const target_url = data.store_url + window.location.pathname;
    
    if (data.text_one && redirectionModal_text_one) redirectionModal_text_one.textContent = data.text_one;
    if (data.text_two && redirectionModal_text_two) redirectionModal_text_two.textContent = data.text_two;
    if (data.store_url && redirectionModal_url) redirectionModal_url.setAttribute('href', target_url);
    
    window.addEventListener('load', function() {
      redirectionModal?.classList.remove('hidden');
    });

    redirectionModal_url.addEventListener('click', () => {
      sessionStorage.setItem('redirection_status', 'true');
    })
  }

  popupModalToggle() {
    const redirectionModal = document.querySelector('#custom-redirection-modal');
    const redirectionModal_close = redirectionModal?.querySelector('.crm-close');
    redirectionModal_close.addEventListener('click', () => {
      redirectionModal.classList.add('hidden');
      sessionStorage.setItem('redirection_status', 'true');
    })
  }
}

if (!window.customElements.get('custom-redirection')) {
  customElements.define('custom-redirection', CustomRedirection)
}